// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1qgM8","productName":"Table_productName__10cwb"};